import { regexDomain } from '../constants/REGEX';

export const formatAmount = (input) => {
  // Remove all non-digit characters
  const cleaned = input.replace(/\D/g, '');

  // Handle the case where the input is being cleared
  if (cleaned === '' || input === '$0.0') {
    return '';
  }

  // Convert cleaned input to a number and handle the case for $0.00
  const numberValue = Number(cleaned) / 100;

  // Format the number with commas for every thousand
  const formattedNumber = numberValue.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return formattedNumber;
};

export const formatPhoneNumber = (input) => {
  // Remove all non-digit characters
  const cleaned = input.replace(/\D/g, '');

  // Apply the phone number format (###) ###-####
  let formattedNumber = '';
  if (cleaned.length > 0) {
    formattedNumber = `(${cleaned.substring(0, 3)}`;
  }
  if (cleaned.length >= 4) {
    formattedNumber += `) ${cleaned.substring(3, 6)}`;
  }
  if (cleaned.length >= 7) {
    formattedNumber += `-${cleaned.substring(6, 14)}`;
  }

  return formattedNumber;
};

// Normalizes a user-entered domain by trimming, lowercasing and stripping any
// protocol, leading "www." and trailing path/slash, e.g. "https://www.Example.com/foo" -> "example.com".
export const normalizeDomain = (input = '') => {
  return String(input)
    .trim()
    .toLowerCase()
    .replace(/^[a-z]+:\/\//, '')
    .replace(/^www\./, '')
    .replace(/\/.*$/, '');
};

// Returns true when the given string is a valid bare website domain.
export const isValidDomain = (input = '') => {
  return regexDomain.test(normalizeDomain(input));
};

export const formatPercentage = (input) => {
  // Remove all non-digit characters
  const cleaned = input.replace(/\D/g, '');

  // Handle the case where the input is being cleared or only zeros
  if (cleaned === '' || input === '0.0') {
    return '';
  }

  // Convert cleaned input to a number (as cents)
  let numberValue = Number(cleaned) / 100;

  // Bound the value between 0 and 100
  numberValue = Math.max(0, Math.min(100, numberValue));

  // Format the number with commas for every thousand, two decimal places, no percent sign
  return numberValue.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};
